"use strict";

exports.__esModule = true;
exports.default = void 0;
var _getNative = _interopRequireDefault(require("./_getNative.js"));
var _root = _interopRequireDefault(require("./_root.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/* Built-in method references that are verified to be native. */
var DataView = (0, _getNative.default)(_root.default, 'DataView');
var _default = exports.default = DataView;